export const paperclip = {
    "v": "5.9.6",
    "fr": 60,
    "ip": 0,
    "op": 120,
    "w": 750,
    "h": 750,
    "nm": "Main render",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        368.785,
                        360.835,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -132.023,
                                                        163.102
                                                    ],
                                                    [
                                                        -187.29600000000002,
                                                        84.515
                                                    ],
                                                    [
                                                        -70.615,
                                                        -111.522
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -173.64,
                                                        138.332
                                                    ],
                                                    [
                                                        -162.526,
                                                        42.898
                                                    ],
                                                    [
                                                        -33.321999999999996,
                                                        -174.178
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -132.023,
                                                        163.102
                                                    ],
                                                    [
                                                        -162.526,
                                                        42.898
                                                    ],
                                                    [
                                                        -70.615,
                                                        -111.522
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -217.566,
                                                        125.325
                                                    ],
                                                    [
                                                        -249.481,
                                                        34.702
                                                    ],
                                                    [
                                                        -84.053,
                                                        -122.392
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -250.915,
                                                        90.206
                                                    ],
                                                    [
                                                        -214.362,
                                                        1.353
                                                    ],
                                                    [
                                                        -31.18,
                                                        -172.601
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -217.566,
                                                        125.325
                                                    ],
                                                    [
                                                        -214.362,
                                                        1.353
                                                    ],
                                                    [
                                                        -84.053,
                                                        -122.392
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -217.566,
                                                        125.325
                                                    ],
                                                    [
                                                        -249.481,
                                                        34.702
                                                    ],
                                                    [
                                                        -84.053,
                                                        -122.392
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -250.915,
                                                        90.206
                                                    ],
                                                    [
                                                        -214.362,
                                                        1.353
                                                    ],
                                                    [
                                                        -31.18,
                                                        -172.601
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -200.145,
                                                        143.67
                                                    ],
                                                    [
                                                        -217.566,
                                                        125.325
                                                    ],
                                                    [
                                                        -214.362,
                                                        1.353
                                                    ],
                                                    [
                                                        -84.053,
                                                        -122.392
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -64.312,
                                                        180.746
                                                    ],
                                                    [
                                                        -87.671,
                                                        171.032
                                                    ],
                                                    [
                                                        -153.565,
                                                        101.11000000000001
                                                    ],
                                                    [
                                                        -65.967,
                                                        -109.536
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -64.312,
                                                        180.746
                                                    ],
                                                    [
                                                        -132.389,
                                                        152.436
                                                    ],
                                                    [
                                                        -134.969,
                                                        56.392
                                                    ],
                                                    [
                                                        -37.97,
                                                        -176.861
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -64.312,
                                                        180.746
                                                    ],
                                                    [
                                                        -87.671,
                                                        171.032
                                                    ],
                                                    [
                                                        -134.969,
                                                        56.392
                                                    ],
                                                    [
                                                        -65.967,
                                                        -109.536
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -137.242,
                                                        166.33
                                                    ],
                                                    [
                                                        -157.686,
                                                        151.769
                                                    ],
                                                    [
                                                        -205.952,
                                                        69.57000000000001
                                                    ],
                                                    [
                                                        -74.647,
                                                        -114.783
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -137.242,
                                                        166.33
                                                    ],
                                                    [
                                                        -196.822,
                                                        123.894
                                                    ],
                                                    [
                                                        -178.077,
                                                        30.434
                                                    ],
                                                    [
                                                        -32.68000000000001,
                                                        -173.70499999999998
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -137.242,
                                                        166.33
                                                    ],
                                                    [
                                                        -157.686,
                                                        151.769
                                                    ],
                                                    [
                                                        -178.077,
                                                        30.434
                                                    ],
                                                    [
                                                        -74.647,
                                                        -114.783
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -132.023,
                                                        163.102
                                                    ],
                                                    [
                                                        -187.29600000000002,
                                                        84.515
                                                    ],
                                                    [
                                                        -70.615,
                                                        -111.522
                                                    ],
                                                    [
                                                        47.702000000000005,
                                                        -194.739
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        193.57500000000002,
                                                        -39.129
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        29.807,
                                                        179.283
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -41.81,
                                                        102.887
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -173.64,
                                                        138.332
                                                    ],
                                                    [
                                                        -162.526,
                                                        42.898
                                                    ],
                                                    [
                                                        -33.321999999999996,
                                                        -174.178
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        173.014,
                                                        -120.15299999999999
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        69.584,
                                                        169.188
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -31.715,
                                                        142.66400000000002
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -110.283,
                                                        176.041
                                                    ],
                                                    [
                                                        -132.023,
                                                        163.102
                                                    ],
                                                    [
                                                        -162.526,
                                                        42.898
                                                    ],
                                                    [
                                                        -70.615,
                                                        -111.522
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        110.358,
                                                        -157.446
                                                    ],
                                                    [
                                                        156.282,
                                                        23.527
                                                    ],
                                                    [
                                                        87.893,
                                                        138.427
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.974
                                                    ],
                                                    [
                                                        -0.954,
                                                        160.973
                                                    ],
                                                    [
                                                        -23.501,
                                                        72.126
                                                    ],
                                                    [
                                                        31.011,
                                                        -19.46
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 180,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        }
    ],
    "markers": [],
    "__complete": true
}